import AppModule from "@/app/modules/module";
import Guards from '@/app/middleware/guards'
import {authManager, webManager} from '@/app/middleware/register'

export default new AppModule('c-news')
    .routers([
        {
            path: '/company/',
            component: AppModule.layout.CompanyLayout,
            beforeEnter: Guards([webManager,authManager]),
            children: [
                {
                    path: 'news/:id',
                    name:'manager.news.detail',
                    component: () => import('./views/news'),
                    meta: {
                        title: 'お知らせ',
                        bodyClass: ''
                    }
                }
            ]
        },
    ])
    .register()
